module.exports = __webpack_public_path__ + "static/img/AL.ef96a34d.jpg";